export const initModals = function (config) {

  $('div.modal-content figure.table').removeClass('table');

  $(window).scroll(function() {
    if ($(this).scrollTop() > 250) {
      $('div.modal-buttons').fadeIn();
    }
  });

  $('div.modal-buttons > div.buttons > button:last-of-type').on('click', function(){
    $(this).closest('div.buttons').toggleClass('show');
  });

  $('div.modal-buttons > div.buttons > button[data-bs-toggle="modal"]').on('click', function(){
    $(this).closest('div.buttons').removeClass('show');
  });
}
